var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"confirm"},[_c('div',{staticClass:"container"},[_c('Modal',{attrs:{"responseType":_vm.responseType,"showModal":_vm.showModal,"response":_vm.response,"success":_vm.success,"failed":_vm.failed}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }